import type { IDropDownItem } from "@similarweb/ui-components";
import { Dropdown } from "@similarweb/ui-components";
import {
    StyledDropdownParent,
    StyledSingleSelectDDItem,
    StyledSingleSelectDDItemText,
} from "app/pages/sales-intelligence/common-components/dropdown/styles";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import useDelayedAction from "app/pages/sales-intelligence/hooks/useDelayedAction";
import useUncontrolledDropdown from "app/pages/sales-intelligence/hooks/useUncontrolledDropdown";
import { buildDropdownSelectedItemsFromArray } from "app/pages/sales-intelligence/utils/dropdowns";
import SignalFilterDropdownButton from "app/pages/sales-intelligence/sub-modules/signals/components/filters/shared/FilterDropdown/SignalFilterDropdownButton/SignalFilterDropdownButton";
import { DROPDOWN_AUTO_OPEN_DELAY } from "app/pages/sales-intelligence/sub-modules/signals/constants/dropdown";

type FilterValue = string;

type DropdownItem = Omit<IDropDownItem, "id"> & {
    id: FilterValue;
};

type Props = {
    selectedValue: FilterValue | undefined;
    options: readonly FilterValue[];
    autoOpen?: boolean;
    onValueChange(value: FilterValue): void;
};

const SignalTrafficDirectionsFilter = ({ selectedValue, options, autoOpen = false, onValueChange }: Props) => {
    const selectedItems: Record<FilterValue, boolean> = buildDropdownSelectedItemsFromArray(
        selectedValue ? [selectedValue] : [],
    );

    const { dropdownRef, onUncontrolledOpen } = useUncontrolledDropdown();

    useDelayedAction(DROPDOWN_AUTO_OPEN_DELAY, onUncontrolledOpen, autoOpen);

    const handleClick = (item: DropdownItem): void => {
        onValueChange(item.id);
    };

    return (
        <StyledDropdownParent id="traffic-direction-dd">
            <Dropdown
                ref={dropdownRef}
                appendTo="#traffic-direction-dd"
                selectedIds={selectedItems}
                width={150}
                onClick={handleClick}
            >
                <SignalFilterDropdownButton
                    id="traffic-direction"
                    hasValue={typeof selectedValue !== "undefined"}
                >
                    {typeof selectedValue !== "undefined" ? (
                        <I18n
                            data-automation="traffic-direction-dd-dd-button-text"
                            translatable={{
                                key: `si.signals.changing-traction-direction.${selectedValue}.label`,
                            }}
                        />
                    ) : null}
                </SignalFilterDropdownButton>

                {...options.map((option) => (
                    <StyledSingleSelectDDItem
                        id={option}
                        key={option}
                    >
                        <I18n
                            data-automation="traffic-direction-dd-dd-item-text"
                            element={StyledSingleSelectDDItemText}
                            translatable={{
                                key: `si.signals.changing-traction-direction.${option}.label`,
                            }}
                        />
                    </StyledSingleSelectDDItem>
                ))}
            </Dropdown>
        </StyledDropdownParent>
    );
};

export default SignalTrafficDirectionsFilter;
